/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import $http from '../../plugins/axios';

export const getProgramDetails = async (programId: string) => {
  try {
    let res;
    await $http.get(`/program/${programId}`).then((response) => {
      // console.log(response.data.sys_settings);
      res = response.data;
      return res;
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateProgram = async (programData: any) => {
  try {
    console.log('inside update Program Service');
    let updateRes;
    await $http.put('/program', programData).then((response: any) => {
      console.log('program Response', response);
      updateRes = response.data;
      return updateRes;
    });
    return updateRes;
  } catch (error) {
    return error;
  }
};
// export const updateEmailTemplate = async (emailTemplates: any) => {
//   try {
//     let updateRes;
//     await $http.post('/program/email/event/create', emailTemplates).then((response: any) => {
//       console.log('program Response', response);
//       updateRes = response.data;
//       return updateRes;
//     });
//     return updateRes;
//   } catch (error) {
//     return error;
//   }
// };
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const updateEmailTemplate = async (emailTemplates: any) => {
  const res = await $http.post('/program/email/event/create', emailTemplates);
  return res;
};
